
 // Vycentruje mapu
  const getCenter = (marker1, marker2) => {

    return {
      lat: (marker1.lat + marker2.lat) / 2  ,
      lng: (marker1.lng + marker2.lng) / 2
    };
  };
  const mapStyles = [
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        { color: '#e9e9e9' },
        { lightness: 17 }
      ]
    },
    // ... další styly ...
  ];


  const options = {
    zoomControl: false,            // Skryje ovládání zoomu
    mapTypeControl: false,        // Skryje ovládání typu mapy
    scaleControl: false,          // Skryje měřítko
    streetViewControl: false,     // Skryje ovládání Street View
    rotateControl: false,         // Skryje ovládání rotace
    fullscreenControl: false,      // Skryje tlačítko pro celou obrazovku
    style: mapStyles

  };

    // Aktualizace střed mapy, když se markery změní
    const getMapZoom = (distance) => {
        const distanceNum = Math.round(distance / 1000)

        if(distanceNum <= 8){
          return 10
        }
        else if(distanceNum >= 9 && distanceNum < 50){
          return 9
        }
        else if(distanceNum > 50){
          return 8
        }
        
    }

    const containerStyle = {
      width: '100%',
      height: '100%',
    }
      

  


  

export  {getCenter, options, getMapZoom, containerStyle}